import React, {useState,useEffect} from 'react'
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import './App.css'
import Navbar from './Components/Navbar'
import Footer from './Components/Pages/Footer/footer'
import Home from './Components/Pages/Home'
import { FooterObj } from './Components/Pages/Data'

function App() {
    const [isLoading, setLoading] = useState(true)

    function fakeRequest(){
        return new Promise(resolve => setTimeout(() => resolve(), 2500))
    }

    useEffect(() => {
        fakeRequest().then(() => {
            const el = document.querySelector('.loader-container')
            if(el){
                el.remove()
                setLoading(!isLoading)
            }
        })
    },[])

    if (isLoading){
        return null
    }
    
    return(
        <Router>
            <Navbar />
            <Switch>
                <Home />
            </Switch>
            <Footer {...FooterObj}/>
        </Router>
    )
}

export default App
